import { render, staticRenderFns } from "./MatchStandingsComponent.vue?vue&type=template&id=2cc17b0e&scoped=true&"
import script from "./MatchStandingsComponent.vue?vue&type=script&lang=js&"
export * from "./MatchStandingsComponent.vue?vue&type=script&lang=js&"
import style0 from "./MatchStandingsComponent.vue?vue&type=style&index=0&id=2cc17b0e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc17b0e",
  null
  
)

export default component.exports